import clsx from 'clsx';
import type { ForwardedRef } from 'react';
import { forwardRef } from '../../forward-ref.js';
import { IconMenu } from '../../icons/index.js';
import { withStyleProps } from '../../with-style-props.js';
import { IconButton } from '../button/icon-button.js';
import type { CommonProps } from '../types.js';

export interface UNSTABLE_AppHeaderNavButtonProps extends CommonProps {
  isOpen: boolean;
  onPress: () => void;
}

function UNSTABLE_AppHeaderNavButton(
  { isOpen, onPress, UNSAFE_className, UNSAFE_style }: UNSTABLE_AppHeaderNavButtonProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <IconButton
      aria-expanded={isOpen}
      icon={<IconMenu />}
      size="small"
      // TODO
      aria-label="Open menu"
      variant="tertiary"
      onPress={onPress}
      ref={ref}
      UNSAFE_className={clsx('cim-app-header-nav-toggle', UNSAFE_className)}
      UNSAFE_style={UNSAFE_style}
    />
  );
}

const _UNSTABLE_AppHeaderNavButton = withStyleProps(forwardRef(UNSTABLE_AppHeaderNavButton, 'AppHeaderNavButton'));

export { _UNSTABLE_AppHeaderNavButton as UNSTABLE_AppHeaderNavButton };
